import { render, staticRenderFns } from "./loadBtn.vue?vue&type=template&id=36359a37"
import script from "./loadBtn.vue?vue&type=script&lang=js"
export * from "./loadBtn.vue?vue&type=script&lang=js"
import style0 from "./loadBtn.vue?vue&type=style&index=0&id=36359a37&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports